
<template>
  <div class="box" ref="box">
    <div class="top-ctrl">
      <i class="icon icon-close-range" @click="close"></i>            
    </div>
    <div class="top-switch">
      <span 
        class="tag-item" 
        :class="{active:activeTab == key}" 
        @click="activeTab = key"
        v-for="(tab,key) in tabMap"
      >{{tab.name}}</span>
    </div>
    <div class="rule-desc">{{tabMap[activeTab].desc}}</div>
    <div class="rank-list">
      <div class="rank-item" v-for="(node,index) in rankList">
        <div class="rank-num">
          <div class="medal" :class="`rank-num-${index+1}`">
            <div class="circle">{{index+1}}</div>
            <div class="ribbon">
              <!-- <div class="ribbon-l"></div>
              <div class="ribbon-r"></div> -->
            </div>
          </div>
        </div>
        <div class="user-info">
          <div class="name">{{node.name}}</div>
          <div class="money">
            <span class="label">{{getDict(81)}}</span>
            <span>{{node.money | readableNum}}</span>
          </div>
        </div>
        <div class="rank-status">
          <div class="middle-box" :class="{
            'status0':index == node.lastRank,
            'status1':index < node.lastRank || node.lastRank == -1,
            'status-1':index > node.lastRank && node.lastRank != -1,
          }">
            <div class="core">
              <div class="border"></div>
            </div>
            <div class="left"></div>
            <div class="right"></div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket  } from '../common'
  import { invokeNative } from '../common'
  import TalkInput from '../components/talkInput'
  import { mapState, mapGetters } from 'vuex'

  

  export default {
    props: {
    },
    data(){
      return {
        activeTab:'streamer',
        tabMap:{
          streamer:{
            name:getDict(82),
            desc:getDict(84)
          },
          user:{
            name:getDict(83),
            desc:getDict(85)
          },
        },
        streamerRankList:[],
        userRankList:[],
        /*rankList:[
          {
            name:'1111111',
            money:123123,
            lastRank:1,
          },{
            name:'22222',
            money:123123,
            lastRank:2,
          },{
            name:'33333',
            money:123123,
            lastRank:0,
          },{
            name:'44444',
            money:123123,
            lastRank:3,
          },{
            name:'5555',
            money:123123,
            lastRank:-1,
          },{
            name:'5555',
            money:123123,
            lastRank:-1,
          },{
            name:'5555',
            money:123123,
            lastRank:-1,
          },{
            name:'555511',
            money:123123,
            lastRank:-1,
          },
        ]*/
      }
    },
    computed:{
      ...mapState(['userData','goingTime']),
      rankList(){
        let list = [];
        switch(this.activeTab){
          case 'streamer':
            for(let node of this.streamerRankList){
              // debugger
              list.push({
                name:node.streamer_info.streamer,
                money:node.rank_info.money,
                lastRank:node.rank_info.last_rank,
              })
            }
          break;
          case 'user':
            for(let node of this.userRankList){
              list.push({
                name:node.user_info.name,
                money:node.rank_info.money,
                lastRank:node.rank_info.last_rank,
              })
            }
          break;
        }
        return list;
      }
    },
    watch:{
      activeTab(){
        this.getDate();
      }
    },
    components: {
    },
    methods: {
      getDict,
      async getStreamRank(){
        let data = await webSocket.get('/user/popularity_rank/find',{
        });
        // console.log(123)
        this.streamerRankList = data.item_infos || [];
      },
      async getUserRank(){
        let data = await webSocket.get('/user/reward_rank/find',{
        });
        this.userRankList = data.item_infos || [];
      },
      getDate(){
        switch(this.activeTab){
          case "streamer":
          this.getStreamRank();
          break;
          case "user":
          this.getUserRank();
          break;
        }
      },
      close(){
        this.$emit('close')
      }
    },
    mounted(){
    },
    created(){
      this.getDate();
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .box{
    height: 100%;
    // height: 4.4rem !important;
    // height: 4rem !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #222;
    // padding: 0.1rem;
    // padding-bottom:0;
    position: relative; 
    min-height: 0; 
    // flex: 1;
    // border:1px solid #f00;

    .top-ctrl{
      box-sizing: content-box;
      $size:0.2rem;
      height: $size;
      padding: 0.1rem;
      .icon{
        float: right;
        width:$size;
        height: $size;
      }
    }
    .top-switch{
      $font-size: 0.25rem;
      font-size: $font-size;
      color: #fff;
      display: flex;
      justify-content: space-around;
      .tag-item{
        padding-bottom: 0.08rem;
        &.active{
          color: #ffc952;
          border-bottom:1px solid  #ffc952;
        }
      }
    }
    .rule-desc{
      font-size: 0.16rem;
      color: #fff;
      padding: 0.1rem;
    }
    .rank-list{
      $font-size: 0.2rem;
      min-height: 0;
      // height: 2rem;
      flex: 1;
      overflow: scroll;
      background-color: #232324;
      color: #fff;
      font-size: $font-size;
      .rank-item{
        display: flex;
        padding: 0.07rem 0;
        &:not(:last-child){
          border-bottom: 1px dotted #5d5f61;
        }


        .rank-num{
          $size: 0.3rem;
          margin: 0.05rem 0.1rem 0;
          .medal{
            position: relative;
            .circle{
              position: relative;
              background-color: #3d3d3d;
              padding-bottom: $size*0.1;
              width: $size;
              height: $size;
              line-height: $size*0.9;
              font-size: $size * 0.6;
              text-align: center;
              border-style: solid;
              border-width: 0.03rem;
              border-radius: 50%;
              border-color: #3d3d3d;
              font-weight: 600;
              z-index: 2;
            }
            .ribbon{
              $ribbon-size:$size/1.5;
              width: $ribbon-size;
              height: $ribbon-size;
              position: absolute;
              overflow: hidden;
              left:($size - $ribbon-size)/2;
              top: $size - $ribbon-size/2.4;
              bottom: -$ribbon-size/1.3;
              border: #{$ribbon-size/2} solid rgba(0,0,0,0);
              border-bottom-color: rgba(0,0,0,0); 
              // $ribbon-size:$size/1.5;
              // width: $ribbon-size;
              // height: $ribbon-size;
              // position: absolute;
              // overflow: hidden;
              // left:($size - $ribbon-size)/2;
              // bottom: -$ribbon-size/1.3;
              // .ribbon-l,.ribbon-r{
                
              //   position: absolute;
              //   width: $ribbon-size;
              //   height: $ribbon-size;
              //   background-color: rgba(0,0,0,0);
              //   transform: rotate(45deg);
              //   top: -$ribbon-size/2.8
              // }
              // .ribbon-l{
              //   left:-$ribbon-size/2;
              // }
              // .ribbon-r{
              //   right:-$ribbon-size/2;
              // }
            }
            

            &.rank-num-1{
              .circle{
                background-color: #f1b11e;
                border-color: #fdcb58;
              }
              .ribbon{
                border-left-color: #e35422;
                border-top-color: #dd410a;
                border-right-color: #dd410a;
              }
            }
            &.rank-num-2{
              .circle{
                background-color: #95a7b2;
                border-color: #d1e3e8;
              }
              .ribbon{
                border-left-color: #8e9da5;
                border-top-color: #8497a1;
                border-right-color: #8497a1;
              }
            }
            &.rank-num-3{
              .circle{
                background-color: #b48662;
                border-color: #c59d73;
              }
              .ribbon{
                border-left-color: #ba8b5f;
                border-top-color: #a17042;
                border-right-color: #a17042;
              }
            }
          }
          
        }
        .user-info{
          flex:1;
          flex-shrink: 1;
          min-width: 0;
          .name{
            width: 100%;
            font-weight: 600;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .money{
            font-size: $font-size * 0.8;
          }
        }
        .rank-status{
          width: 0.5rem;
          $size-lenght:0.12rem;
          $color: #7b7b7b;
          display: flex;
          justify-content: center;
          align-items: center;
          .middle-box{
            width: 0;
            background-color: #{$color};
            height: $size-lenght*2;
            width: 0.04rem;

            position: relative;
            

            &.status1,&.status-1{
              .core{
                position: absolute;
                top: -0.02rem;
                left: 0.02rem;
                width: 0;
                height: 0;
                transform: rotate(45deg);
                .border{
                  box-sizing: content-box;
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: $size-lenght;
                  height: $size-lenght;
                  border-top: 0.04rem solid #{$color};
                  border-left: 0.04rem solid #{$color};
                }
              }

              &.status-1{
                transform:scaleY(-1);
              }
            }




            &.status0{
              background:none;
              .left{
                position: absolute;
                top: $size-lenght - 0.02rem;
                right: 0.04rem;
                width: $size-lenght;
                height: 0;
                border-top:0.04rem solid  #{$color};
              }
              .right{
                position: absolute;
                top: $size-lenght - 0.02rem;
                left: 0.04rem;
                width: $size-lenght;
                height: 0;
                border-top: 0.04rem solid  #{$color};
              } 
            }
          }
        }
        
      }
    }
    
  }
</style>
